import React from "react";
import { FaReact, FaNodeJs, FaDatabase, FaCloud } from "react-icons/fa";
import {
  SiTypescript,
  SiRedux,
  SiAzuredevops,
  SiFigma,
  SiNuxtdotjs,
  SiVuedotjs,
  SiAngular,
  SiReact,
} from "react-icons/si";

const stackItems = [
  { id: 1, label: "React", icon: <FaReact />, angle: "0deg", color: "#61dafb" },
  {
    id: 2,
    label: "TypeScript",
    icon: <SiTypescript />,
    angle: "35deg",
    color: "#3178c6",
  },
  { id: 3, label: "React Native", icon: <SiReact />, angle: "70deg", color: "#00d8ff" },
  { id: 4, label: "Redux", icon: <SiRedux />, angle: "100deg", color: "#764abc" },
  { id: 5, label: "Vue", icon: <SiVuedotjs />, angle: "130deg", color: "#42b883" },
  { id: 6, label: "Nuxt", icon: <SiNuxtdotjs />, angle: "160deg", color: "#00dc82" },
  { id: 7, label: "Angular", icon: <SiAngular />, angle: "190deg", color: "#dd0031" },
  { id: 8, label: "Node.js", icon: <FaNodeJs />, angle: "220deg", color: "#68a063" },
  { id: 9, label: "APIs", icon: <FaDatabase />, angle: "250deg", color: "#f97316" },
  { id: 10, label: "Cloud", icon: <FaCloud />, angle: "280deg", color: "#38bdf8" },
  { id: 11, label: "Azure DevOps", icon: <SiAzuredevops />, angle: "310deg", color: "#0078d4" },
  { id: 12, label: "Figma", icon: <SiFigma />, angle: "340deg", color: "#f472b6" },
];

const SkillsMap = () => {
  return (
    <section className="section skills-map" id="skills-map">
      <div className="section-title" data-aos="fade-up">
        <h2>Stack Map</h2>
        <div className="underline"></div>
        <p className="projects-description">
          A visual map of the tools and platforms I rely on most.
        </p>
      </div>

      <div className="skills-map-wrapper" data-aos="fade-up" data-aos-delay="100">
        <div className="skills-map-core">
          <span>Core</span>
          <strong>Product + UX</strong>
        </div>
        <div className="skills-map-ring ring-one"></div>
        <div className="skills-map-ring ring-two"></div>
        <div className="skills-map-nodes">
          {stackItems.map((item) => (
            <div
              key={item.id}
              className="skills-map-node"
              style={{
                "--node-angle": item.angle,
                "--node-color": item.color,
              }}
            >
              <div className="skills-map-node-content">
                <span className="skills-map-icon">{item.icon}</span>
                <span className="skills-map-label">{item.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkillsMap;
